import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import queryString from "query-string";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import Payment from "../../../components/payment";
import HeaderAdmin from "../header";
import { styles } from "./styles";

class Service extends React.Component {
  componentDidMount() {
    const { adminService = {} } = this.props;
    let serviceCode = "";
    let location = this.props.location;
    const parsed = queryString.parse(location.search);
    if (location && location.state && location.state.adminService)
      serviceCode = location.state.adminService.no;
    else if (parsed.serviceCode) {
      serviceCode = parsed.serviceCode;
    } else serviceCode = adminService.no;
    this.props.getServiceByCode({ no: serviceCode });
  }
  render() {
    const { classes, t, adminService = {}, ...props } = this.props;
    let serviceCode = adminService.no;
    return (
      <>
        <HeaderAdmin {...props} />

        {serviceCode && <Payment {...props} serviceCode={serviceCode} />}
      </>
    );
  }
}

Service.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  adminService: state.service.adminService,
  role: state.user.user.roleId.role,
});

const mapDispatch = (dispatch) => ({
  getServiceByCode: dispatch.service.getServiceByCode,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(Service)));
